"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EscrowAccountRef = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.EscrowAccountRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.escrow_account.label',
    fallbackLabel: 'Merchant order timeframe',
    type: Field_type_1.FieldType.Enum,
    options: [
        { key: 'YES', label: 'fields.enm.escrow_account.options.YES', fallbackLabel: 'Yes, 100% of the funds are set aside from our own funds.' },
        { key: 'PARTIALLY', label: 'fields.enm.escrow_account.options.PARTIALLY', fallbackLabel: 'Yes, partially.' },
        { key: 'NO', label: 'fields.enm.escrow_account.options.NO', fallbackLabel: 'No, not at all.' },
    ],
    trackFieldValueWithAnalytics: false,
};
